module.exports = __webpack_public_path__ + "img/fig7.6.bf9919c0.png";